import type { SubAsset } from '../../common/sub-asset';

export const getConditionRatingColorsMapping = (rating: number = 0) => {
	return {
		'text-green-600': rating < 2,
		'text-yellow-600': rating < 3 && rating >= 2,
		'text-red-600': rating >= 3,
	};
};

// Build the breadcrumb path for a selected sub-asset ID
export const buildSubAssetPath = (subAssets: SubAsset[], selectedId: string): SubAsset[] => {
	const path: SubAsset[] = [];
	const findPath = (assets: SubAsset[], id: string): boolean => {
		for (const asset of assets) {
			if (asset.id === id) {
				path.unshift(asset);
				return true;
			}
			if (asset.children && findPath(asset.children, id)) {
				path.unshift(asset);
				return true;
			}
		}
		return false;
	};
	findPath(subAssets, selectedId);
	return path;
};

export const getTreeView = (allSubAssets: SubAsset[]): SubAsset[] => {
	// Build the tree structure
	const buildTree = (parentId?: string | null): SubAsset[] => {
		return allSubAssets
			.filter((subAsset) => {
				// If parentId is null or undefined, we are looking for root nodes
				if (!parentId) {
					return !subAsset.parentSubAssetId;
				}
				// Otherwise, match the parentSubAssetId
				return subAsset.parentSubAssetId === parentId;
			})
			.map((subAsset) => ({
				...subAsset,
				children: buildTree(subAsset.id as string),
			}));
	};
	return buildTree();
};

/**
 * Checks if the given assetId is valid (not empty and not 'new')
 * @param assetId - The asset ID to validate
 * @returns true if the asset ID is valid, false otherwise
 */
export const checkAssetIdIsValid = (assetId: unknown) => {
	// Check if assetId is a non-empty string and not 'new'
	if (typeof assetId !== 'string' || !assetId.trim()) {
		return false;
	}
	return assetId !== 'new';
};
